import { Component } from "preact";
import { isNullOrUndefined } from "util";
import { isNumber, numberWithCommas, numberWithoutCommas, getCurrencySymbol } from "../../../../utils/utility";
import { preventDefault, validateAmountWeb, showRupee } from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";
import style from "./style";
import constant from "../../../../utils/constants";

export default class MerchantAmountInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.constraints.value ? props.constraints.value : "",
      isAmountChecked: false,
      showAmountInput: true
    };
    this.isFixedAmount = !!props.constraints.value;
    this.showAmountCheck = !props.constraints[constant.MANDATORY_VALIDATION];
    this.amtInput = "";
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      let error = nextProps.errorName;
      const fieldName = this.props.name;
      if (
        error &&
        (error.indexOf(fieldName) === 0 && error.toLowerCase().indexOf(`${fieldName.toLowerCase()} amount`) !== 0)
      ) {
        error = error.replace(fieldName, "Amount");
      }
      this.setState({ isError: nextProps.isError, errorName: error });
    }
  }

  validateNumberInput = event => {
    if (!isNumber(event)) {
      preventDefault(event);
    }
  };

  updateValue = amt => {
    this.props.updateFormValue(this.props.index, numberWithoutCommas(amt));
    this.props.updateAmount(Number(numberWithoutCommas(amt)));
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: this.props.name });
  };

  validateWebAmount = event => {
    if (!validateAmountWeb(event)) {
      return preventDefault(event);
    }
  };

  setAmountField = event => {
    if (event && event.target) {
      let showRs = showRupee(event, false);
      const amt = numberWithCommas(event.target.value);
      if (amt === "") {
        showRs = showRupee(event, false);
      }
      // Minus prevoius value from total amount
      this.state.inputValue && this.props.updateAmount(-Number(numberWithoutCommas(this.state.inputValue)));
      this.setState({ showRupeeInAmount: showRs, inputValue: amt });
      this.updateValue(amt);
    }
  };

  pasteNumber = event => {
    setTimeout(() => {
      if (event && event.target) {
        const number = event.target.value;
        if (isNumber(number)) {
          this.setAmountField(event);
        } else {
          event.target.value = "";
        }
      }
    }, 0);
  };

  toogleAmountCheck = () => {
    if (this.state.isAmountChecked) {
      this.props.updateAmount(-Number(numberWithoutCommas(this.state.inputValue)));
      this.updateValue("");
    } else {
      this.updateValue(this.state.inputValue);
    }
    this.setState(prevState => ({ isAmountChecked: !prevState.isAmountChecked }));
  };

  toggleAmountInput = val => {
    this.state.showRupeeInAmount && this.setState({ showAmountInput: val });
    val &&
      setTimeout(() => {
        if (this.amtInput) {
          this.amtInput.focus();
        }
      }, 0);
  };

  componentDidMount() {
    if (!this.showAmountCheck && this.isFixedAmount) {
      this.updateValue(this.state.inputValue);
    }
  }

  render(
    { name, constraints, placeholder, subText },
    { inputValue, isAmountChecked, showAmountInput, showRupeeInAmount, errorName }
  ) {
    const maxLength = constraints.maxLength ? constraints.maxLength : "";
    return this.isFixedAmount ? (
      <div className={`${style["pos-r"]}`}>
        <div className={`${style.clear}`}>
          <div className={`${style["amt-label"]} ${style.ibl}`}>{placeholder}</div>
          <div className={`${style["amt-label"]} ${style.ibl} ${style.tr} ${style.cb}`}>
            <span className={`${style["rupee-sign"]}`}>{getCurrencySymbol()}</span>
            {numberWithCommas(inputValue)}
            {this.showAmountCheck && (
              <div className={`${style["pos-r"]} ${style.ib} ${style["c-mark-box"]}`}>
                <div className={`${style["custom-check"]} ${style.ib}`}>
                  <input type="checkbox" checked={isAmountChecked} onClick={this.toogleAmountCheck} />
                  <span className={`${style["c-mark"]} ${style.ib}`} area-hidden="true" />
                </div>
              </div>
            )}
          </div>
        </div>
        {subText && <p className={`input-info ${style.info}`}>{subText}</p>}
      </div>
    ) : (
      <div className={`${style["pos-r"]}`}>
        <div className={`${style.clear}`}>
          <div className={`${style["amt-label"]} ${style.ibl}`}>{placeholder}</div>
          <div className={`${style["amt-label"]} ${style.ibl} ${style.tr}  ${style.cb}`}>
            {showRupeeInAmount && (
              <span id="rupee" className={`${style["rupee-sign"]}`}>
                {getCurrencySymbol()}
              </span>
            )}
            {showAmountInput && (
              <input
                ref={inp => (this.amtInput = inp)}
                name={name}
                type="text"
                inputmode="numeric"
                value={inputValue}
                placeholder="Enter amount"
                maxlength={maxLength}
                onKeyDown={this.validateWebAmount}
                onKeyUp={this.setAmountField}
                onFocus={this.clearErrors}
                onBlur={() => this.toggleAmountInput(false)}
                className={`${style["amount-inp"]} ${showRupeeInAmount ? style["has-val"] : ""}`}
                onPaste={this.pasteNumber}
                autocomplete="on"
              />
            )}
            {!showAmountInput && (
              <span className={`${style["fix-amt"]}`} onClick={() => this.toggleAmountInput(true)}>
                {inputValue}
              </span>
            )}
          </div>
        </div>

        {subText && <p className={`input-info ${style.info}`}>{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/merchant-amount/index.js